import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // Importez les styles Leaflet
import React, { useEffect, useState } from 'react';
import { Circle, LayerGroup, MapContainer, Marker, TileLayer, Tooltip } from 'react-leaflet';
import { useLocation } from 'react-router-dom';

const DeliveryLocationMap = ({ centers, centercoords }) => {
  const zoom = 16;

  const location = useLocation();
  const [coordonatesCenter, setCoordonatesCenter] = useState([0, 0]);

  useEffect(() => {
    setCoordonatesCenter(centercoords);
  }, [, centers]);

  return (
    <>
      <MapContainer
        center={centercoords}
        zoom={zoom}
        style={{
          height: location.pathname.includes('search') ? '100vh' : '500px',
          width: location.pathname.includes('search') ? '100%' : '100%',
        }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {/* Utilisez LayerGroup pour regrouper plusieurs couches */}
        <LayerGroup>
          {/* Ajoutez le Marker avec l'icône personnalisée */}
          {centers.map((center) => (
            <Marker
              key={center.id}
              position={[
                parseFloat(center.locationCoords.split(',')[0]),
                parseFloat(center.locationCoords.split(',')[1]),
              ]}
              icon={
                new L.DivIcon({
                  className: 'custom-marker',
                  html: `<div class="badge-container"><span class="badge bg-tertiary" style="font-size: 24px;"><ion-icon name="train-outline"></ion-icon></span>
                  </div>`,
                })
              }
            >
              <Tooltip>
                <div style={{ textAlign: 'center' }}>
                  <strong>{center.addressEmplacementDelivery}</strong>
                  <br />
                  Price: ${center.VehiculeAnnonce.reservationPrice}
                </div>
              </Tooltip>
            </Marker>
          ))}

          {/* Ajoutez le Circle avec une couleur personnalisée */}
          <Circle center={centercoords} radius={400} fillColor="blue" fillOpacity={0.2} />
        </LayerGroup>
      </MapContainer>
    </>
  );
};

export default DeliveryLocationMap;
